import { NgModule } from '@angular/core';

import { AnalyticsRouterService } from './analytics-router.service';
import { AnalyticsService } from './analytics.service';

@NgModule({
  providers: [
    AnalyticsRouterService,
    AnalyticsService,
  ]
})
export class AnalyticsModule {
}
